import React, {
  ReactNode,
  useContext,
  createContext,
  useState,
  Dispatch,
  SetStateAction,
} from 'react'

export type DisplayMode = 'MAP' | 'LIST'
export interface DisplayContextState {
  displayMode: DisplayMode
}

export interface DisplayContextProps extends DisplayContextState {
  setDisplayMode: Dispatch<SetStateAction<DisplayContextState['displayMode']>>
}

const DisplayContext = createContext<DisplayContextProps | null>(null)

export const useDisplayContext = (): DisplayContextProps => {
  const context = useContext(DisplayContext)

  if (!context) {
    throw new Error(
      'useDisplayContext must be used within DisplayContextProvider',
    )
  }

  return context
}

export const DisplayContextProvider: React.FC<{
  children: ReactNode
  props: DisplayContextState
}> = ({ children, props }) => {
  const [displayMode, setDisplayMode] = useState<
    DisplayContextState['displayMode']
  >(props.displayMode)
  return (
    <DisplayContext.Provider
      value={{
        displayMode,
        setDisplayMode,
      }}
    >
      {children}
    </DisplayContext.Provider>
  )
}
